var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrillcutStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 586 489",
    width: 586,
    height: 489,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "drillcut-SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #592c82 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m353.5 313c41.1-35.8-34-192.7-159.5-255.7q0.2 0.5 0.4 1c7.2 19.6 12 37.8 14.6 54.9 3.4 21.2 4 45.1-2.8 70.8-19.9 78.8-96.4 131.9-183.2 198 193-120.8 299.5-41.9 330.5-69zm-90.4-228.3c76.1 49.4 118.7 117.3 132.8 172.7-0.7-135.4 85.4-212.4 131.6-256.4-61.5 25.3-145.1 119.6-264.4 83.7zm121 261.2c-31 26.4-77.4 6.1-145.5-0.6 72.1 12.4 143.3 57.5 228.8 144-38.1-67.8-58.6-127-66.9-178.9-2 15.5-7.6 27.9-16.4 35.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrillcutStar);
export default __webpack_public_path__ + "static/media/drillcut_star.62a93aac134494a5d140c2e349183bba.svg";
export { ForwardRef as ReactComponent };